<div [ngClass]="{connected: user!== null && onlineIcon && onlineSrv.isOnline(user.id)}">
    <img
        [ngStyle]="{ 'width.px': size, 'height.px': size }"
        src="{{image}}"
        width="40"
        height="40"
        border="0"
        class=""
    />
    <em></em>
</div>